const CommodityType = [
    {
        value: 'General Cargo',
        label: 'General Cargo',
    },
    {
        value: 'Special Cargo',
        label: 'Special Cargo',
    },
]

const CommodityTypeChild = [
    {
        value: 'Dangerous Goods',
        label: 'Dangerous Goods',
    },
    {
        value: 'Temperature Controlled / Pharma',
        label: 'Temperature Controlled / Pharma',
    },
    {
        value: 'Other Special Commodity',
        label: 'Other Special Commodity',
    },
]
const ClassDescription = [
    {
        label: 'Class 1 - Explosives',
        options: [
            { label: 'Substances and articles which have a mass explosion hazard', value: 'Class 1.1' },
            { label: 'Substances and articles which have a projection hazard but not a mass explosion hazard', value: 'Class 1.2' },
            { label: 'Substances and articles which have a fire hazard and either a minor blast hazard or a minor projection hazard or both', value: 'Class 1.3' },
            { label: 'Substances and articles which present no significant hazard; only a small hazard in the event of ignition or initiation during transport with any effects largely confined to the package', value: 'Class 1.4' },
            { label: 'Very insensitive substances which have a mass explosion hazard', value: 'Class 1.5' },
            { label: 'Extremely insensitive articles which do not have a mass explosion hazard', value: 'Class 1.6' },

        ],
    },
    {
        label: 'Class 2 - Gases',
        options: [
            { label: 'Flammable gases', value: 'Class 2.1' },
            { label: 'Non-flammable, non-toxic gases', value: 'Class 2.2' },
            { label: 'Toxic gases', value: 'Class 2.3' },
        ],
    },
    {
        label: 'Class 3 - Flammable Liquids',
        value: 'Class 3'
    },
    {
        label: 'Class 4 - Flammable Solids',
        options: [
            { label: 'Flammable solids', value: 'Class 4.1' },
            { label: 'Substances liable to spontaneous combustion', value: 'Class 4.2' },
            { label: 'Substances which, in contact with water, emit flammable gases', value: 'Class 4.3' },
        ],
    },
    {
        label: 'Class 5 - Oxidizers; Organic Peroxides',
        options: [
            { label: 'Oxidizing substances', value: 'Class 5.1' },
            { label: 'Organic peroxides', value: 'Class 5.2' },
        ],
    },
    {
        label: 'Class 6 - Toxic Substances; Infectious Substances',
        options: [
            { label: 'Toxic substances', value: 'Class 6.1' },
            { label: 'Infectious substances', value: 'Class 6.2' },
        ],
    },
    {
        label: 'Class 7 - Radioactive Material',
        value: 'Class 7'
    },
    {
        label: 'Class 8 - Corrosives',
        value: 'Class 8'
    },
    {
        label: 'Class 9 - Miscellaneous Dangerous Goods',
        value: 'Class 9'
    }, {
        value: '',
        label: 'Select Class Description',
    }
]
const PackingGroup =[
    {
        value: '',
        label: 'Select Packing Group',
    },
    {
        value: 'Group 1 - High  Danger',
        label: 'Group 1 - High  Danger',
    },
    {
        value: 'Group 2 - Medium Danger',
        label: 'Group 2 - Medium Danger',
    },
    {
        value: 'Group 3 - Low Danger',
        label: 'Group 3 - Low Danger',
    },
]
const TemperatureControlType =[
    {
        value: '',
        label: 'Select Temperature Control Type',
    },
    {
        value: 'Active',
        label: 'Active',
    },
    {
        value: 'Passive',
        label: 'Passive',
    },
]
const TemperatureControlledRange = [
    {
        value: '',
        label: 'Select Temperature Control Range',
    },
    {
        value: 'General Pharma',
        label: 'General Pharma',
    },
    {
        value: 'Frozen : -20 to 0 degree celicius',
        label: 'Frozen : -20 to 0 degree celicius',
    },
    {
        value: 'Chilled : 2 to 8 degree celcius',
        label: 'Chilled : 2 to 8 degree celcius',
    },
    {
        value: 'Ambient : 15 to 25 degree celcius',
        label: 'Ambient : 15 to 25 degree celcius',
    },
]
const SpecialCommodityType =[
    {
        value: '',
        label: 'Select Special Commodity Type',
    },
    {
        value: 'Perishable',
        label: 'Perishable',
    },
    {
        value: 'Valuable',
        label: 'Valuable',
    },
    {
        value: 'Fragile',
        label: 'Fragile',
    },
    {
        value: 'Other',
        label: 'Other',
    },
]
const Handling = [
    {
        value: "Tiltable and Stackable",
        label: "Tiltable and Stackable",
    },
    {
        value: 'Tiltable and Non-stackable',
        label: "Tiltable and Non-stackable",
    },
    {
        value: 'Non-Tiltable and Stackable',
        label: 'Non-Tiltable and Stackable',
    },
    {
        value: "Non Tiltable and Non stackable",
        label: "Non Tiltable and Non stackable",
    },
]


const checkStackableandTurnable = (handlingValue) => {
  let stackable = false;
  let turnable = false;
  switch (handlingValue) {
    case "Tiltable and Stackable":
      stackable = true;
      turnable = true;
      break;
    case "Tiltable and Non-stackable":
      stackable = false;
      turnable = true;
      break;

    case "Non-Tiltable and Stackable":
      stackable = true;
      turnable = false;
      break;

    case "Non Tiltable and Non stackable":
      stackable = false;
      turnable = false;
      break;

    default:
  }
  return {
    stackable,
    turnable
  }
};

const PaymentType = [
    {
        value: '',
        label: 'Select Payment Type',
    },
    {
        value: 'Prepaid',
        label: 'Prepaid',
    },
    {
        value: 'Collect',
        label: 'Collect',
    },
]
const PackagingDetailsType = [
    {
      value: 'Packaging Type',
      label: 'Packaging Type',
    },
    {
      value: 'Shipment Total',
      label: 'Shipment Total',
    },
]
const WeightUnit = [
    {
        value: '',
        label: 'Select Weight Unit',
    },
    {
        value: 'KG/UNIT',
        label: 'KG/UNIT',
    },
    {
        value: 'LB/UNIT',
        label: 'LB/UNIT',
    },
]
const PackageType = [
    {
        value: '',
        label: 'Select Packaging Type',
    },
    {
        value: 'Box',
        label: 'Box',
    },
    {
        value: 'Pallet',
        label: 'Pallet',
    },
    {
        value: 'Crate',
        label: 'Crate',
    },
    {
        value: 'Loose',
        label: 'Loose',
    },
]
const VolumeUnit = [
    {
        value: '',
        label: 'Select Volume Unit',
    },
    {
        value: 'CBM',
        label: 'CBM',
    },
    {
        value: 'CC',
        label: 'CC',
    },
    {
        value: 'CFT',
        label: 'CFT',
    },
]
const ShipmentWeightUnit = [
    {
        value: '',
        label: 'Select Weight Unit',
    },
    {
        value: 'KG',
        label: 'KG',
    },
    {
        value: 'LB',
        label: 'LB',
    },
]
const IncoTerms = [
    {
        value: '',
        label: 'Select Incoterms',
    },
    {
        label: 'Imports',
        options: [
            // {
            //     value: 'Imports',
            //     label: '',
            // },
            {
                value: 'FOB',
                label: 'FOB',
            },
           
            {
                value: 'EXW',
                label: 'EXW',
            },
            {
                value: 'FCA',
                label: 'FCA',
            },
            {
                value: 'FAS',
                label: 'FAS',
            },
        ],
    },
    {
        label: 'Exports',
        options: [
            // {
            //     value: 'Export',
            //     label: 'Export',
            // },
            {
                value: 'DDP',
                label: 'DDP',
            },
            {
                value: 'DAP',
                label: 'DAP',
            },
            {
                value: 'DAT',
                label: 'DAT',
            },
            {
                value: 'CPT',
                label: 'CPT',
            },
            {
                value: 'CIP',
                label: 'CIP',
            },
            {
                value: 'CIF',
                label: 'CIF',
            },
            {
                value: 'CFR',
                label: 'CFR',
            },
        ],
    }
]
const IncoTerms1 = [
    {value: 'All',
        label: 'All' },
    {
        value: 'None',
        label: 'None',
    },
    {
        label: 'Imports',
        options: [
            // {
            //     value: 'Imports',
            //     label: '',
            // },
            {
                value: 'FOB',
                label: 'FOB',
            },
           
            {
                value: 'EXW',
                label: 'EXW',
            },
            {
                value: 'FCA',
                label: 'FCA',
            },
            {
                value: 'FAS',
                label: 'FAS',
            },
        ],
    },
    {
        label: 'Exports',
        options: [
            // {
            //     value: 'Export',
            //     label: 'Export',
            // },
            {
                value: 'DDP',
                label: 'DDP',
            },
            {
                value: 'DAP',
                label: 'DAP',
            },
            {
                value: 'DAT',
                label: 'DAT',
            },
            {
                value: 'CPT',
                label: 'CPT',
            },
            {
                value: 'CIP',
                label: 'CIP',
            },
            {
                value: 'CIF',
                label: 'CIF',
            },
            {
                value: 'CFR',
                label: 'CFR',
            },
        ],
    }
]
const PackagingUnit = [
    {
        value: '',
        label: 'Select Unit',
    },
    {
        value: 'CM',
        label: 'CM',
    },
    {
        value: 'INCH',
        label: 'INCH',
    },
]
const CompanyType= [
    {
        value: '',
        label: 'Select Company Type',
    },
    {
        value: 'Proprietorship Firm',
        label: 'Proprietorship Firm',
    },
    {
        value: 'Partnership Firm',
        label: 'Partnership Firm',
    },
    {
        value: 'Public / Private Limited Conpany / LLP',
        label: 'Public / Private Limited Conpany / LLP',
    },
]
const AddressProof = [
    {
        value: '',
        label: 'Select Address Proof',
    },
    {
        value: 'Land Line Telephone Bill',
        label: 'Land Line Telephone Bill',
    },
    {
        value: 'Electricity Bill',
        label: 'Electricity Bill',
    },
    {
        value: 'Bank Passbook',
        label: 'Bank Passbook',
    },
    {
        value: 'Bank Account Statement',
        label: 'Bank Account Statement',
    },
    {
        value: 'Registered Lease / Sale Agreement',
        label: 'Registered Lease / Sale Agreement of office premises',
    },
    {
        value: 'GST certificate',
        label: 'GST certificate',
    },
    {
        value: 'Udhyam certificate',
        label: 'Udhyam certificate',
    },
    {
        value: 'Proof of Address issued by Bank Managers ',
        label: 'Proof of Address issued by Bank Managers of Scheduled Commercial Banks / Multinational Foreign Banks',
    },
    {
        value: 'Registration Certificate issued under Shops and Establishments Act',
        label: 'Registration Certificate issued under Shops and Establishments Act',
    },
]
const AddressProofPublic = [
    ...AddressProof,
    {
        value: 'Copy Of Board Resolution along with authorized signatory list and specimen signature',
        label: 'Copy Of Board Resolution along with authorized signatory list and specimen signature',
    },
]
const AuthorizedSignatory = [
    {
        value: '',
        label: 'Select Authorized Signatory',
    },
    {
        value: 'PAN',
        label: 'PAN',
    },
    {
        value: 'Driving License',
        label: 'Driving License',
    },
    {
        value: 'Passport',
        label: 'Passport',
    },
]


export {
    CommodityType,
    CommodityTypeChild,
    TemperatureControlType,
    TemperatureControlledRange,
    SpecialCommodityType,
    Handling,
    PaymentType,
    WeightUnit,
    PackagingDetailsType,
    PackageType,
    VolumeUnit,
    ShipmentWeightUnit,
    IncoTerms,
    IncoTerms1,
    PackagingUnit,
    CompanyType,
    AddressProof,
    AddressProofPublic,
    AuthorizedSignatory,
    ClassDescription,
    PackingGroup,
    checkStackableandTurnable
}